import React from 'react';
import { Sun, Moon, Star, Flame, Sparkles, Clock, Bell, Heart, CalendarDays, BookOpen, Zap, Sunrise, MoonStar, Sunset, Wheat, TreePalm, Wine, Droplets } from 'lucide-react';

// Custom SVG — two Shabbat candles with flames (stroke-based, lucide style)
export const ShabbatCandles = ({ style, size = 24, color = 'currentColor', className }) => {
  const c = style?.color || color;
  return (
    <svg
      width={style?.width || size}
      height={style?.height || size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Left candle body (taller) */}
      <rect x="6" y="12" width="4" height="10" rx="1" stroke={c} strokeWidth="1.5" />
      {/* Left wick */}
      <line x1="8" y1="10" x2="8" y2="12" stroke={c} strokeWidth="1.5" />
      {/* Left flame (filled teardrop) */}
      <path d="M8 10 C6 8 6 6 8 5 C10 6 10 8 8 10 Z" fill={c} />
      {/* Right candle body (shorter) */}
      <rect x="14" y="14" width="4" height="8" rx="1" stroke={c} strokeWidth="1.5" />
      {/* Right wick */}
      <line x1="16" y1="12" x2="16" y2="14" stroke={c} strokeWidth="1.5" />
      {/* Right flame (filled teardrop) */}
      <path d="M16 12 C14 10 14 8 16 7 C18 8 18 10 16 12 Z" fill={c} />
    </svg>
  );
};

export const WIDGET_ICON_MAP = {
  Sun, Moon, Star, Flame, Sparkles, Clock, Bell, Heart, CalendarDays, BookOpen, Zap, Sunrise,
  MoonStar, Sunset, ShabbatCandles, Wheat, TreePalm, Wine, Droplets,
};
